import {Component} from '@angular/core';
import {SubFormComponent} from '../../_subform';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {PermitTypesProvider} from '@providers/education-types/permit-types.provider';
import {SpecialistEnums} from '@namespaces/specialist.namespace';

@Component({
    selector: 'app-permit-subform',
    template: `
        <g-row>
            <g-col [width]="400">
                <app-form-group [fbControl]="form.get('type')" [marginBottom]="form.get('type').value ? null : 0">
                    <app-form-label [required]="true">Наименование документа</app-form-label>
                    <app-form-select [fbControl]="form.get('type')" [values]="permitTypesProvider.data$ | async" (change)="onTypeChange()">
                    </app-form-select>
                </app-form-group>
            </g-col>
            <g-col>
                <app-form-group [marginBottom]="0">
                    <app-form-label>&nbsp;</app-form-label>
                    <button type="button" class="button-transparent" (click)="removeSelfFromParentArray()">
                        <lib-icon type="trash" [size]="12"></lib-icon>
                        Удалить
                    </button>
                </app-form-group>
            </g-col>
        </g-row>
        <ng-container *ngIf="form.get('type').value as type">
            <g-row>
                <g-col [width]="200">
                    <app-form-group [fbControl]="form.get('number')">
                        <app-form-label [required]="true">Номер</app-form-label>
                        <app-form-input [fbControl]="form.get('number')"></app-form-input>
                    </app-form-group>
                </g-col>
                <g-col [width]="130">
                    <app-form-group [fbControl]="form.get('date')">
                        <app-form-label [required]="true">Дата выдачи</app-form-label>
                        <app-form-date [fbControl]="form.get('date')"></app-form-date>
                    </app-form-group>
                </g-col>
                <g-col [width]="130">
                    <app-form-group [fbControl]="form.get('date_end')">
                        <app-form-label [required]="true">Окончание</app-form-label>
                        <app-form-date [fbControl]="form.get('date_end')"></app-form-date>
                    </app-form-group>
                </g-col>
            </g-row>
            <app-form-group [fbControl]="form.get('grade')" [width]="200" *ngIf="gradeValuesToSelect.length">
                <app-form-label [required]="true">{{gradeFieldTitle}}</app-form-label>
                <app-form-select [fbControl]="form.get('grade')" [values]="gradeValuesToSelect"></app-form-select>
            </app-form-group>
            <g-row>
                <g-col [width]="230">
                    <app-form-group [marginBottom]="0">
                        <app-form-label>Копии документа</app-form-label>
                        <app-files-uploader [fbControl]="form.get('files')" [multiple]="false" [loadTarget]="'Noap'">
                            <small class="info">Рекомендуем заполнить. <br>
                                PDF, JPG, PNG, TIFF не&nbsp;более 10&nbsp;Мб
                            </small>
                        </app-files-uploader>
                    </app-form-group>
                </g-col>
                <g-col [width]="240" *ngIf="showFacility">
                    <app-form-group [fbControl]="form.get('issued_by')">
                        <app-form-label [required]="true">Образовательное учреждение</app-form-label>
                        <app-form-input [fbControl]="form.get('issued_by')"></app-form-input>
                    </app-form-group>
                </g-col>
            </g-row>
        </ng-container>
    `
})

export class PermitSubformComponent extends SubFormComponent {
    formGroupTemplate = new FormGroup({
        type: new FormControl(''),      // Тип документа
        number: new FormControl(''),    // Номер
        date: new FormControl(''),      // Дата начала
        date_end: new FormControl(''),  // Дата окочания
        issued_by: new FormControl(''),  // Образовательное учреждение
        grade: new FormControl(''),     // Группы допусков
        files: new FormArray([]),        //
    });

    public showFacility = false;

    public gradeValuesToSelect = [];

    public gradeFieldTitle = '';

    private gradeValuesByType = {
        [SpecialistEnums.PermitType.workingOnHigh]: [
            {id: 1, title: '1'},
            {id: 2, title: '2'},
            {id: 3, title: '3'},
        ],
        [SpecialistEnums.PermitType.electrosecurityAccess]: [
            {id: 1, title: 'I'},
            {id: 2, title: 'II'},
            {id: 3, title: 'III'},
            {id: 4, title: 'IV'},
            {id: 5, title: 'V'},
        ],
    };

    private gradeTitlesByType = {
        [SpecialistEnums.PermitType.workingOnHigh]: 'Группа',
        [SpecialistEnums.PermitType.electrosecurityAccess]: 'Группа допуска',
    };

    constructor(
        public permitTypesProvider: PermitTypesProvider,
    ) {
        super();
    }

    afterInit() {
        this.onTypeChangeHandle(+this.form.get('type').value, true);
    }

    onTypeChange() {
        this.onTypeChangeHandle(+this.form.get('type').value);
    }

    private onTypeChangeHandle(type: number, init = false) {
        this.showFacility = type === SpecialistEnums.PermitType.radiationSafety;

        this.gradeValuesToSelect = this.gradeValuesByType[type] || [];
        this.gradeFieldTitle = this.gradeTitlesByType[type] || 'Группа';

        if (!init) {
            this.resetForm();
            this.form.get('type').patchValue(type || '');
        }
    }
}
